import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  accountNumber,
  apiKey,
  password,
  username,
  userPassMap,
} from '../internal.js'

const credentialTypes = [username, password, apiKey] as const
const locationCredentialTypes = [accountNumber] as const

export type exlaCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const exlaDocumentTypes = [
  'appointment-confirmation',
  'contact-time-critical',
  'customs-documents',
  'delivery-photo',
  'invoice',
  'letter-of-authority',
  'lumper-certificate',
  'other',
  'pickup-photo',
  'proof-of-delivery',
  'signed-bol',
  'weight-and-research-inspection',
  'weights-and-research-photos',
] as const satisfies readonly DocumentType[]

export const exla: CarrierDef<exlaCredType> = {
  name: 'Estes Express Lines',
  scac: 'exla',
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    {
      id: 'guaranteed_ten_am',
      name: 'Guaranteed by 10am',
      guaranteed: true,
      guaranteedByTime: '10:00',
    },
    {
      id: 'guaranteed_twelve_pm',
      name: 'Guaranteed by 12pm',
      guaranteed: true,
      guaranteedByTime: '12:00',
    },
    {
      id: 'guaranteed_five_pm',
      name: 'Guaranteed by 5pm',
      guaranteed: true,
      guaranteedByTime: '17:00',
    },
    { id: 'volume_truckload_basic', name: 'Volume and Truckload Basic' },
    {
      id: 'volume_truckload_economy',
      name: 'Guaranteed Volume and Truckload Economy',
      guaranteed: true,
    },
    {
      id: 'volume_truckload_standard',
      name: 'Guaranteed Volume and Truckload Standard',
      guaranteed: true,
    },
    {
      id: 'volume_truckload_exclusive_use',
      name: 'Guaranteed Exclusive Use',
      guaranteed: true,
    },
  ],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['api-key', 'apiKey'],
    ['account-number', 'ref1'],
  ],
  engineLayers: [
    'rating',
    'bol',
    'pickup',
    'cancel',
    'profinder',
    'tracking',
    'documents',
    'invoice',
  ],
  documentTypes: exlaDocumentTypes,
  credentialConfig: {
    'api-key': { hideFromFreightview: true },
    'account-number': { customerIdentifier: true },
  },
}
